ALLOWED_CONTROLLER = 'service_visits'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  autocomplete_source= ->
    $('*[data-selector="service_visits_filter"]').data('locationsSource')

  $('*[data-selector="service_visits_filter"]').autocomplete
    source: autocomplete_source()

$(document).ready(ready)
$(document).on('turbo:load', ready)
